import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import loadable from "@loadable/component";
const ValentineSlide = loadable(
  () => import("./carousel-slides/ValentineSlide"),
);
const ImageLoader = loadable(() => import("../common/ImageLoader"));
const OHCanadaHero = loadable(() => import("./hero/OHCanadaHero"));
const AirMiniSlide = loadable(() => import("./carousel-slides/AirMiniSlide"));
const CozyAirSlide = loadable(() => import("./carousel-slides/CozyAirSlide"));

const SpringAirSlide = loadable(
  () => import("./carousel-slides/SpringAirSlide"),
);
const AUAirSlide = loadable(() => import("./carousel-slides/AUAirSlide"));
import { useIsMobile } from "../../hooks";
import { SUPPORTED_REGIONS } from "../../../shared/enums";

import newAir from "assets/images/landingAir/newyear/mila-air-specs.png";
import newAirWebp from "assets/images/landingAir/newyear/mila-air-specs.png?as=webp";
import newAirSm from "assets/images/landingAir/newyear/mila-air-specs-sm.png";
import newAirWebpSm from "assets/images/landingAir/newyear/mila-air-specs-sm.png?as=webp";

import springSlide from "assets/images/landingAir/hero/spring-background.jpg";
import springSlideWebp from "assets/images/landingAir/hero/spring-background.jpg?as=webp";

import springSlideSm from "assets/images/landingAir/hero/spring-background-sm.jpg";
import springSlideWebpSm from "assets/images/landingAir/hero/spring-background-sm.jpg?as=webp";

/**
 * @returns {JSX.Element}
 * @constructor
 */

const HeroAirSliderChristmas = ({ localization, handleBuyNow }) => {
  const { region } = localization;
  const regional = SUPPORTED_REGIONS[region] || SUPPORTED_REGIONS.US;
  const isAu = regional === SUPPORTED_REGIONS.AU;
  const isMobile = useIsMobile(769);
  const [isSliderInitialized, setIsSliderInitialized] = useState(false);
  const [progress, setProgress] = useState(-100);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setPrefersReducedMotion(mq.matches);
    update();
    mq.addEventListener?.("change", update);
    return () => mq.removeEventListener?.("change", update);
  }, []);

  const handleBeforeChange = (index) => {
    setCurrentSlide(index);
  };

  useEffect(() => {
    if (!isSliderInitialized) return;
    setProgress(-100);

    const interval = setInterval(() => {
      setProgress((prev) => (prev >= 0 ? -100 : prev + 1));
    }, 60);

    const handleResize = () => {
      setProgress(-100);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", handleResize);
    };
  }, [isSliderInitialized, currentSlide]);

  const settings = {
    dots: !isAu,
    infinite: !isAu,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: !prefersReducedMotion && !isAu,
    autoplaySpeed: 6000,
    pauseOnHover: true,
    pauseOnFocus: true,
    centerMode: true,
    centerPadding: "35px",
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          centerMode: true,
          centerPadding: "15px",
        },
      },
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
        },
      },
    ],
    onInit: () => {
      setIsSliderInitialized(true);
    },
    beforeChange: (_, nextIdx) => {
      handleBeforeChange(nextIdx);
    },
  };

  return (
    <section
      className={`hero-refresh hero-refresh--newyear${isAu ? " hero-refresh--au" : ""}`}
      style={{ "--progress": `${progress}%` }}
    >
      <h1 className="screen-reader-text">
        Mila — award-winning smart air purifiers for a healthier home
      </h1>
      <div className="container">
        {isAu ? (
          <div className="hero-refresh__slider hero-refresh__slider--single">
            <AUAirSlide
              isMobile={isMobile}
              handleBuyNow={handleBuyNow}
              regional={regional}
            />
          </div>
        ) : (
          <Slider {...settings} className="hero-refresh__slider">
            {/* <SpringAirSlide isMobile={isMobile} handleBuyNow={handleBuyNow} /> */}
            {(region === SUPPORTED_REGIONS.US || region === SUPPORTED_REGIONS.CA) && (
              <CozyAirSlide />
            )}

            {region === SUPPORTED_REGIONS.CA && (
              // <OHCanadaHero isMobile={isMobile} handleBuyNow={handleBuyNow} />
              <SpringAirSlide isMobile={isMobile} handleBuyNow={handleBuyNow} />
            )}
            {/* {region === SUPPORTED_REGIONS.CA && (
              <OHCanadaHero isMobile={isMobile} handleBuyNow={handleBuyNow} />
            )}*/}
            <ImmersiveAir isMobile={isMobile} />

            {/* {region !== SUPPORTED_REGIONS.CA && (
              <SpringSlide isMobile={isMobile} handleBuyNow={handleBuyNow} />
            )} */}
          </Slider>
        )}
      </div>
    </section>
  );
};

export default HeroAirSliderChristmas;

function ImmersiveAir({ isMobile }) {
  return (
    <div className="hero-item hero-item--immersive">
      <div className="hero-item__content">
        {isMobile && (
          <strong className="hero-item__subtitle">MEET THE NEW AIR 3</strong>
        )}
        <h2 className="hero-item__title">
          Quieter. Tougher. <br />
          More powerful than ever.
        </h2>
        <div className="hero-item__description">
          <p>
            Air3 is our most advanced purifier yet — built with a
            state-of-the-art Nidec motor and custom fan for exceptional
            durability and performance.
          </p>
        </div>
        <a
          href="https://milacares.com/buy"
          className="hero-item__button button button--white"
        >
          Preorder Now
        </a>
      </div>
      <div className="hero-item__media">
        <strong className="hero-item__media-tag">Air 3</strong>
        <ImageLoader
          className="hero-item__image img-relative"
          placeholderAspectRatio={1320 / 617}
          image={newAir}
          webp={newAirWebp}
          smallImage={newAirSm}
          smallWebp={newAirWebpSm}
          alt="The Mila air Sale"
          noLazyLoad
          fetchPriority="high"
          responsiveWidth={1024}
        />
      </div>
    </div>
  );
}

// function SpringSlide({ isMobile, handleBuyNow }) {
//   return (
//     <div className="hero-item hero-spring hero-spring--slide">
//       <ImageLoader
//         className="hero-item__image img-relative"
//         placeholderAspectRatio={1320 / 617}
//         image={springSlide}
//         webp={springSlideWebp}
//         smallImage={springSlideSm}
//         smallWebp={springSlideWebpSm}
//         alt="The hello, spring and goodbye, allergies"
//         noLazyLoad
//         responsiveWidth={768}
//       />
//       <div className="hero-spring__badge">
//         <p>
//           <strong>“Best Overall Air Purifier for Allergies”</strong> — Popular
//           Science
//         </p>
//       </div>
//       <div className="hero-spring__grid">
//         <div className="hero-spring__column">
//           <h2 className="hero-spring__title">
//             Hello,
//             <br /> Spring.
//           </h2>
//         </div>
//         <div className="hero-spring__column">
//           <h2 className="hero-spring__title">
//             Goodbye,
//             <br /> Allergies.
//           </h2>
//         </div>
//       </div>
//       <div className="hero-spring__footer">
//         {!isMobile && (
//           <p>Stop allergies in their tracks this spring with Mila.</p>
//         )}
//         <button
//           type="button"
//           className="hero-spring__button button button--white"
//           onClick={(e) => handleBuyNow(e)}
//         >
//           Preorder Now
//         </button>
//       </div>
//     </div>
//   );
// }
